import { Field } from "formik";

const IntakeWitnessDefendantStatementFocusQuestionsFields = ({ errors, touched, values, nested }) => {
    return (
        <div className="form-wrapper general-information">
            <div className="content">
                <h3>Statement Focus</h3>

                <div className="form-row single-col">
                    <strong>
                        <p>Suggested questions for insurance, course & scope/work information:</p>
                    </strong>

                    <ol type="a">
                        <li><span>Confirm Def driver's name, address, telephone number, and DOB (see above info.) If any missing info., please obtain.</span></li>
                        <li><span>Def Driver's version of what happened.</span></li>
                        <li><span>Where was he/she coming from/going? (from home to work?) What is his/her home address?</span></li>
                        <li><span>Who his/her employer is, job title, job responsibilities: length of employment?</span></li>
                        <li><span>If he/she ever uses car for work purposes. If so, to do what? How often? What part of his/her job requires him/her to use this vehicle?</span></li>
                        <li><span>Was he/she working at time of incident or doing anything work related at all?</span></li>
                        <li><span>Was he/she running an errand for employer or anyone else at the time of the accident?</span></li>
                        <li><span>Does employer provide insurance policy for the car at all? If so, what is the insurance carrier?</span></li>
                        <li><span>Does employer provide him/her with a work vehicle to perform any work obligations or does employer expect him/her to use their own personal vehicle?</span></li>
                        <li><span>Who is the registered owner of the Defendant's vehicle?</span></li>
                        <li><span>If Defendant does not confirm that they were also the registered owner of the vehicle, did they have permission from the registered owner to drive the vehicle?</span></li>
                        <li><span>If Defendant driver is not the registered owner, please provide name and address of the registered owner(s). Do you know if they had separate insurance for their vehicle?</span></li>
                    </ol>

                    <div className="form-field-wrapper">
                        <label htmlFor="statementFocusQuestions">Statement Focus Questions <small>These are our standard questions. Include any specific questions you would like to be asked in the text box below.</small></label>
                        <Field id="statementFocusQuestions" name={nested ? 'witnessDefendantStatementFocusQuestions.statementFocusQuestions' : 'statementFocusQuestions'} as="textarea" rows="5" />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default IntakeWitnessDefendantStatementFocusQuestionsFields;